import { cn } from "@/lib/utils";
import { AlertTriangle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

type Props = {
  name?: string;
  size?: "sm" | "md" | "lg";
  alerts?: string[];
};

const sizeConfig = {
  sm: "size-8 text-sm",
  md: "size-10 text-base",
  lg: "size-12 text-lg",
};

const LeadAvatar = ({ name, size = "md", alerts }: Props) => {
  const initials = name
    ? name
        .split(" ")
        .filter((word) => word.length > 0)
        .slice(0, 2)
        .map((word) => word.charAt(0).toUpperCase())
        .join("")
    : "?";

  const hasAlerts = alerts && alerts.length > 0;

  if (hasAlerts) {
    return (
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            aria-label="Ver alertas"
            className={cn(
              "flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-red-100 text-red-600",
              sizeConfig[size]
            )}
            onClick={(e) => e.stopPropagation()}
          >
            <AlertTriangle className="size-5" />
          </button>
        </PopoverTrigger>
        <PopoverContent
          side="right"
          align="start"
          className="w-auto max-w-[240px] space-y-1 border-red-100 bg-red-50 p-3 text-xs text-red-700"
          onClick={(e) => e.stopPropagation()}
        >
          {alerts.map((alert, i) => (
            <p key={i}>{alert}</p>
          ))}
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-[lavender] font-semibold text-purple-500",
        sizeConfig[size]
      )}
    >
      {initials}
    </div>
  );
};

export default LeadAvatar;
